const reactSelectDefaultValue = (defaultValue, options) => {
  if (!defaultValue) {
    return null;
  }

  if (Array.isArray(defaultValue)) {
    console.error('Type mismatch, expected String.');
    return null;
  }

  if (!options || (Array.isArray(options) && options.length === 0)) {
    return null;
  }

  return options.slice(0).filter((option) => {
    if (defaultValue === option.value) {
      return option;
    }

    return null;
  });
};

export default reactSelectDefaultValue;
